export const BRAND_ID = '10AA0B00-8C91-4D25-BC4F-CEFEE2E2C305';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

